import dayjs from "dayjs";
import LabelBox from "~/domains/salesCampaign/components/LabelBox/LabelBox";
import { useTranslation } from "react-i18next";
import type { WithT } from "i18next";
import Tag from "~/common/components/Tag/Tag";
import { useForceRerender } from "~/common/hooks/useForceRerender";
import { useEffect } from "react";

interface Props {
  className?: string;
  endDate?: Date;
}

export const SaleEndIndicator = (props: Props) => {
  const { t } = useTranslation();
  const end = dayjs(props.endDate);

  const today = dayjs();

  const days = end.diff(today, "day");

  // let label;
  // if (!props.endDate) {
  //   label = t("feature.salesCampaign.indicator.saleEnd.noEnd");
  // } else if (days >= 1) {
  //   label = t("feature.salesCampaign.indicator.saleEnd.days", { count: days });
  // } else {
  //   label = t("feature.salesCampaign.indicator.saleEnd.today");
  // }

  const label = t("feature.salesCampaign.indicator.saleEnd.noEnd");

  return (
    <LabelBox variant={"inactive"} className={props.className} sx={{ display: "flex", textTransform: "uppercase" }}>
      {label}
    </LabelBox>
  );
};

function getRemainingTime(t: WithT["t"], endDate?: Date) {
  if (!endDate) {
    return t("feature.salesCampaign.indicator.saleEnd.noEnd");
  }

  const today = dayjs();

  const end = dayjs(endDate);

  const days = end.diff(today, "day");

  if (days >= 1) {
    return t("feature.salesCampaign.indicator.saleEnd.days", { count: days });
  } else {
    const hours = end.diff(today, "hour");
    const minutes = end.diff(today, "minute") - hours * 60;
    const seconds = end.diff(today, "second") - hours * 60 * 60 - minutes * 60;
    const remainingTime = `${hours}:${minutes}:${seconds}`;
    return t("feature.salesCampaign.indicator.saleEnd.remaining", { remainingTime });
  }
}

const V2 = (props: Props) => {
  const { t } = useTranslation();
  const label = getRemainingTime(t, props.endDate);
  const rerender = useForceRerender();

  useEffect(() => {
    const interval = setInterval(() => {
      rerender();
    }, 1000);
    return () => clearInterval(interval);
  }, [rerender]);

  return (
    <Tag variant={"salesCampaign"} className={props.className}>
      {label}
    </Tag>
  );
};

SaleEndIndicator.V2 = V2;
